export const pageTypes = [
  { text: 'Article', value: 'article', color: '#FFDFBA' }, // Pastel Orange
  { text: 'Home', value: 'home', color: '#FFDAC1' }, // Pastel Peach
  { text: 'Product', value: 'product', color: '#FFB3E6' }, // Pastel Pink
  { text: 'Category', value: 'category', color: '#E0BAFF' }, // Pastel Purple
  { text: 'Listicle', value: 'listicle', color: '#BAFFC9' }, // Pastel Green
  { text: 'Asset', value: 'asset', color: '#FFFFBA' }, // Pastel Yellow
  { text: 'Case Study', value: 'case study', color: '#BAE1FF' }, // Pastel Blue
  { text: 'Glossary', value: 'glossary', color: '#FFB3BA' }, // Pastel Red
  { text: 'Forum', value: 'forum', color: '#D4EDDA' }, // Pastel Light Green
  { text: 'Other', value: 'other', color: '#E2E3E5' } // Light Gray
]
